import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './detailRow.module.scss';

export const DetailRow = ({ labelId, defaultLabel, children }) => (
    <div className={styles['container']}>
        <FormattedMessage id={labelId} defaultMessage={defaultLabel} className={styles['key']} />
        <div className={styles['value']}>{children}</div>
    </div>
);
